import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import "../../App.css";
import "../../index.css";

const ReleaseNote = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const releaseNoteSeen = localStorage.getItem('releaseNotSeen');
        const latestVersion = '3.1.0';

        if (releaseNoteSeen !== latestVersion) {
            setIsVisible(true);
        }
    }, []);

    const darkTheme = createTheme({
        pallete: {
            mode: 'dark',
        },
    });

    const BootstrapDialog = styled(Dialog)(({ theme }) => ({
        '& .MuiPaper-root': {
            backgroundColor: '#1c1d24',
        },
        '& .MuiDialogContent-root': {
            padding: theme.spacing(2),
        },
        '& .MuiDialogActions-root': {
            padding: theme.spacing(1),
        },
    }));

    const handleClose = () => {
        const latestVersion = '3.1.0';
        localStorage.setItem('releaseNotSeen', latestVersion);
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <ThemeProvider theme={darkTheme} >
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={isVisible}

            >
                {/* LEMBRAR DE ATUALIZAR O NÚMERO DA VERSÃO A CADA MUDANÇA  */}
                {/* ÚLTIMA NOTA v3.1.0  */}
                <DialogTitle sx={{ m: 0, p: 2, color: 'white' }} id="customized-dialog-title">
                    Nota de atualização v3.1.0
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <Typography style={{ color: 'white' }} gutterBottom>
                        CORREÇÕES E ATUALIZAÇÕES APLICADAS:
                    </Typography>
                    <Typography style={{ color: '#ced9d6' }} gutterBottom>
                        <ul className="a">
                            <li>Filtro por etiquetas</li>
                            <li>Implementação de tour interativo</li>
                            <li>Atualizações em tempo real.</li>
                            <li>Notificações.</li>
                            <li>Marcação de membros nos comentários.</li>
                            <li>Usuários ativos visíveis no quadro.</li>
                            <li>Visualização do cursor dos colaboradores dentro dos cartões.</li>
                            <br></br>
                            <li>Adição de notas às listas.</li>
                            <li>Adição de subtarefas em checklists.</li>
                            <li>Exclusão de notas e cartões.</li>
                            <li>Movimentação de listas.</li>
                            <li>Marcar cartões como concluídos.</li>
                            <li>Botão para arquivar cartões.</li>
                            <br></br>
                            <li>Opção de cores de fundo nos quadros.</li>
                            <li>Opção de cores nas listas.</li>
                            <li>Recolhimento de listas para melhor organização visual.</li>
                            <br></br>
                            <li>Melhorias no design dos cartões.</li>
                            <li>Melhorias no design de modais e popovers.</li>
                            <li>Atualização do menu de ajuda.</li>
                            <br></br>
                            <li>Correção de imagens em comentários.</li>
                            <li>Correção do nome de arquivos no download.</li>
                            <li>Suporte a arquivos KML/KMZ.</li>

                        </ul>
                    </Typography>
                </DialogContent>
            </BootstrapDialog>
        </ThemeProvider>
    )
}

export default ReleaseNote;